import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { type SxProps } from '@mui/material/styles'

import { H2, Text } from '@mxenabled/mxui'

import { ThemedSVGImage } from './ThemedSVGImage'
import { ReactComponent as Image } from './images/SaveEnoughToLiveOnBottom.svg'

const ROW_STYLES = {
  alignItems: 'center',
  flexDirection: 'row',
  height: 40,
  justifyContent: 'space-between',
  px: 16,
  py: 2,
}

interface BalanceRowProps {
  label: string
  value: string
  withBorder?: boolean
}

const BalanceRow = ({ label, value, withBorder = false }: BalanceRowProps) => (
  <Stack
    sx={{
      ...ROW_STYLES,
      ...(withBorder && {
        borderBottom: '1px solid',
        borderColor: 'divider',
      }),
    }}
  >
    <Text color="text.secondary" variant="caption">
      {label}
    </Text>
    <Text bold={true} variant="body2">
      {value}
    </Text>
  </Stack>
)

interface SaveEnoughToLiveOnBottomSectionProps {
  content: string
  leftLabel: string
  leftValue: string
  rightLabel: string
  rightValue: string
  sx?: SxProps
}

const SaveEnoughToLiveOnBottomSection = ({
  content,
  leftLabel,
  leftValue,
  rightLabel,
  rightValue,
  sx,
}: SaveEnoughToLiveOnBottomSectionProps) => (
  <Stack sx={{ alignItems: 'center', gap: 12 }}>
    <Box sx={{ display: 'grid', placeItems: 'center' }}>
      <ThemedSVGImage divProps={{ style: { height: 'auto', gridArea: '1 / 1' } }} image={Image} />
      <H2 sx={{ color: 'neutral.contrastText', gridArea: '1 / 1', textAlign: 'center' }}>
        {content}
      </H2>
    </Box>
    <Stack
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        width: 288,
        ...sx,
      }}
    >
      <BalanceRow label={leftLabel} value={leftValue} withBorder={true} />
      <BalanceRow label={rightLabel} value={rightValue} />
    </Stack>
  </Stack>
)

export default SaveEnoughToLiveOnBottomSection
